(() => {
  if (window.__stallaBillingCheckoutInitialized) return;
  window.__stallaBillingCheckoutInitialized = true;

  const selectors = {
    container: '[data-stalla-billing-fields]',
    customerType: '[data-stalla-customer-type]',
    privateFields: '[data-stalla-private-fields]',
    businessFields: '[data-stalla-business-fields]',
    fiscalCode: '[data-stalla-codice-fiscale]',
    businessName: '[data-stalla-ragione-sociale]',
    vatNumber: '[data-stalla-partita-iva]',
    sdiCode: '[data-stalla-codice-sdi]',
    pec: '[data-stalla-pec]',
    error: '[data-stalla-billing-error]',
  };

  const valueOf = (field) => (field && typeof field.value === 'string' ? field.value.trim() : '');
  const getField = (container, selector) => (container ? container.querySelector(selector) : null);

  const setInvalid = (field, invalid = true) => {
    if (!field) return;
    field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
  };

  const setPanelVisible = (panel, visible) => {
    if (!panel) return;
    panel.hidden = !visible;
    panel.setAttribute('aria-hidden', visible ? 'false' : 'true');
    panel.style.display = visible ? '' : 'none';
  };

  const showError = (container, message) => {
    const error = getField(container, selectors.error);
    if (!error) return;
    if (message) {
      error.textContent = message;
      error.hidden = false;
      error.style.display = '';
    } else {
      error.textContent = '';
      error.hidden = true;
      error.style.display = 'none';
    }
  };

  const clearIrrelevantValues = (container, type) => {
    const privateFields = getField(container, selectors.privateFields);
    const businessFields = getField(container, selectors.businessFields);

    if (type === 'Privato' && businessFields) {
      businessFields.querySelectorAll('input, select, textarea').forEach((field) => { field.value = ''; });
    }

    if (type === 'Azienda / Professionista' && privateFields) {
      privateFields.querySelectorAll('input, select, textarea').forEach((field) => { field.value = ''; });
    }
  };

  const toggleFields = (container, options = {}) => {
    if (!container) return;

    const type = valueOf(getField(container, selectors.customerType));
    const privateFields = getField(container, selectors.privateFields);
    const businessFields = getField(container, selectors.businessFields);

    setPanelVisible(privateFields, type === 'Privato');
    setPanelVisible(businessFields, type === 'Azienda / Professionista');

    if (options.clearHidden) clearIrrelevantValues(container, type);

    container.querySelectorAll('[aria-invalid="true"]').forEach((field) => setInvalid(field, false));
    showError(container, '');
  };

  const syncContainersWithSameForm = (sourceContainer) => {
    const formId = sourceContainer && sourceContainer.dataset.formId;
    if (!formId) return;

    const sourceType = valueOf(getField(sourceContainer, selectors.customerType));

    document.querySelectorAll(`${selectors.container}[data-form-id="${formId.replace(/"/g, '\\"')}"]`).forEach((container) => {
      if (container === sourceContainer) return;
      const customerType = getField(container, selectors.customerType);
      if (customerType && customerType.value !== sourceType) {
        customerType.value = sourceType;
        toggleFields(container);
      }
    });
  };

  const setup = () => {
    document.querySelectorAll(selectors.container).forEach((container) => toggleFields(container));
  };

  const validateContainer = (container) => {
    const customerType = getField(container, selectors.customerType);
    const fiscalCode = getField(container, selectors.fiscalCode);
    const businessName = getField(container, selectors.businessName);
    const vatNumber = getField(container, selectors.vatNumber);
    const sdiCode = getField(container, selectors.sdiCode);
    const pec = getField(container, selectors.pec);
    const type = valueOf(customerType);

    [customerType, fiscalCode, businessName, vatNumber, sdiCode, pec].forEach((field) => setInvalid(field, false));
    showError(container, '');
    toggleFields(container);

    let message = '';
    let focusField = null;

    if (!type) {
      message = 'Seleziona il tipo cliente per proseguire al checkout.';
      focusField = customerType;
    } else if (type === 'Privato' && !valueOf(fiscalCode)) {
      message = 'Inserisci il codice fiscale per proseguire al checkout.';
      focusField = fiscalCode;
    } else if (type === 'Azienda / Professionista') {
      if (!valueOf(businessName)) {
        message = 'Inserisci la ragione sociale per proseguire al checkout.';
        focusField = businessName;
      } else if (!valueOf(vatNumber)) {
        message = 'Inserisci la partita IVA per proseguire al checkout.';
        focusField = vatNumber;
      } else if (!valueOf(sdiCode) && !valueOf(pec)) {
        message = 'Inserisci almeno Codice SDI o PEC per proseguire al checkout.';
        focusField = sdiCode || pec;
        setInvalid(sdiCode, true);
        setInvalid(pec, true);
      }
    }

    if (message) {
      setInvalid(focusField, true);
      showError(container, message);
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => focusField && focusField.focus(), 250);
      return false;
    }

    return true;
  };

  const getFormIdForButton = (button) => {
    if (!button) return '';
    return button.getAttribute('form') || (button.closest('form') ? button.closest('form').id : '');
  };

  const getContainerForCheckoutAction = (button, form) => {
    const formId = getFormIdForButton(button) || (form && form.id) || '';
    if (formId) {
      const byForm = document.querySelector(`${selectors.container}[data-form-id="${formId.replace(/"/g, '\\"')}"]`);
      if (byForm) return byForm;
    }

    return button ? button.closest('cart-drawer, .drawer, form, body')?.querySelector(selectors.container) : null;
  };

  const validateBeforeCheckout = (button, form, event) => {
    const container = getContainerForCheckoutAction(button, form);
    if (!container) return true;

    const isValid = validateContainer(container);
    if (!isValid && event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    return isValid;
  };

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('cart:updated', setup);
  document.addEventListener('cart:refresh', setup);

  document.addEventListener('change', (event) => {
    const container = event.target.closest(selectors.container);
    if (!container) return;

    if (event.target.matches(selectors.customerType)) {
      toggleFields(container, { clearHidden: true });
      syncContainersWithSameForm(container);
    } else {
      toggleFields(container);
    }
  }, true);

  document.addEventListener('input', (event) => {
    const container = event.target.closest(selectors.container);
    if (container) showError(container, '');
  }, true);

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton) return;

    const form = checkoutButton.getAttribute('form')
      ? document.getElementById(checkoutButton.getAttribute('form'))
      : checkoutButton.closest('form');

    validateBeforeCheckout(checkoutButton, form, event);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter;
    const isCheckoutSubmit = submitter
      ? submitter.name === 'checkout'
      : Boolean(form.querySelector('button[name="checkout"], input[name="checkout"]'));

    if (!isCheckoutSubmit) return;
    validateBeforeCheckout(submitter, form, event);
  }, true);

  const observer = new MutationObserver(() => {
    window.clearTimeout(window.__stallaBillingSetupTimer);
    window.__stallaBillingSetupTimer = window.setTimeout(setup, 50);
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.setInterval(setup, 1000);
})();
